import store from 'store2'
const defaultMenus = [
  {
    name: 'Dashboard',
    routeName: 'home',
    filterName: 'Home',  //此处filterName亦用于侧边导航按钮图标显示
    isShow: true,
    type: 0
  },
  {
    name: 'SOP Score/class',
    routeName: 'SOP',
    filterName: 'sop', 
    isShow: true,
    type: 0
  },
{
  name: 'Class Table',
  routeName: 'classTab',
  filterName: 'ClassTable',
  isShow: true,
  type: 0
},
{
  name: 'Training Center',
  routeName: 'trainingCenter',
  filterName: 'TrainingCenter',
  isShow: true,
  enableFolder: true,
  type: 0
},
{
  name: 'Service Fee',
  routeName: 'serviceFee',
  filterName: 'ServiceFee',
  isShow: true,
  type: 0
},
// {
//   name: 'My Referrals',
//   routeName: 'myReferrals',
//   filterName: 'MyReferrals',
//   isShow: true,
//   enableFolder: true,
//   type: 0
// },
// {
//   name: 'My Referrals',
//   routeName: 'referrals',
//   filterName: 'MyReferrals',
//   isShow: true,
//   enableFolder: true,
//   type: 0
// },
{
  name: 'Student Comment',
  routeName: 'comments',
  filterName: 'StudentComment',
  isShow: true,
  enableFolder: true,
  type: 0
},
{
  name: 'Complaint List',
  routeName: 'complaintList',
  filterName: 'ComplaintList',
  isShow: true,
  enableFolder: true,
  type: 0
},
{
  name: 'Feedback',
  routeName: 'myFeedback',
  filterName: 'myFeedback',
  isShow: true,
  enableFolder: true,
  type: 0
},
{
  name: 'Home',
  routeName: 'home',
  filterName: 'Home',
  type: 1
},
{
  name: 'Login',
  routeName: 'login',
  filterName: 'Login',
  type: 1
},
{
  name: 'PersonalData',
  routeName: 'newPersonalData',
  filterName: 'PersonalData',
  type: 1
},
{
  name: 'Message',
  routeName: 'message',
  filterName: 'Message',
  type: 1
},
{
  name: 'Flowers',
  routeName: 'flowers',
  filterName: 'Flowers',
  type: 1
},
{
  name: 'Welcome',
  routeName: 'welcome',
  filterName: 'Welcome',
  type: 1
}
]

function getMenu () {
  return store.get('mainMenus') || defaultMenus
}

String.prototype.trimEnd = function (c) {
  if (c == null || c == '') {
    var str = this
    var rg = /s/
    var i = str.length
    while (rg.test(str.charAt(--i)));
    return str.slice(0, i + 1)
  } else {
    var str = this
    var rg = new RegExp(c)
    var i = str.length
    while (rg.test(str.charAt(--i)));
    return str.slice(0, i + 1)
  }
}
import { MyReferralsOld } from "@/api/teachinfo";
export default {
  state: {
    menus: getMenu(),
    whiteList:[],
    messageCount: 0,
    messages: [],
    pointsDialog: {
      dialog: false
    },
    levelDialog: {
      dialog: false
    },
    reportDialog:{
      dialog: false
    },
    cashDialog: {
      dialog: false
    },
    emailDialog: {
      dialog: false
    },
    enrolmentDialog: {
      dialog: false
    },
    feedbackDialog: {
      dialog: false,
      id: ''
    },
    growthValuesDialog:{
      dialog:false
    },
    smallClassDialog:{
      dialog:false,
      id:'',
    },
    aiDialog:{
      dialog:false
    }
  },
  mutations: {
    SET_MENU: (state, {
      menuName,
      value
    }) => {
      let menu = state.menus.find(m => m.name === menuName)
      Object.assign(menu, value)
      store.set('mainMenus', state.menus)
    },
    SET_MENU_SERVER: (state, menu) => {
      store.set('mainMenus', menu)
    },
    SET_WHITE_LIST: (state, whiteList) => {
      state.whiteList = whiteList
    },
    SET_MESSAGE_COUNT: (state, messageCount) => {
      state.messageCount = messageCount
    },
    SET_MESSAGES: (state, messages) => {
      state.messages = messages
    },
    // 暂时没有异步,暂不使用action
    // 没有父子组件关系重控制points弹窗显示
    setPointDialog (state, pointsDialog) {
      state.pointsDialog.dialog = pointsDialog
    },
    setlevelDialog (state, levelDialog) {
      state.levelDialog.dialog = levelDialog
    },
    setReportDialog (state, reportDialog) {
      state.reportDialog.dialog = reportDialog
    },
    setcashDialog (state, cashDialog) {
      state.cashDialog.dialog = cashDialog
    },
    setEmailDialog (state, emailDialog) {
      state.emailDialog.dialog = emailDialog
    },
    setenrolmentDialog (state, enrolmentDialog) {
      state.enrolmentDialog.dialog = enrolmentDialog
    },
    setFeedbackDialog (state, feedbackDialog) {
      state.feedbackDialog.dialog = feedbackDialog.dialog
      state.feedbackDialog.id = feedbackDialog.id
    },
    setGrowthValuesDialog(state,growthValuesDialog){
      state.growthValuesDialog.dialog = growthValuesDialog
    },
    setSmallClassDialog(state,res){
      state.smallClassDialog.dialog=res.dialog
      state.smallClassDialog.id=res.id
    },
    setAiDialog (state, aiDialog) {
      state.aiDialog.dialog = aiDialog
    },
  },
  actions: {
    setMenu ({
      commit
    }, hosts) {
      if (!hosts) return
      var _menu = defaultMenus.map(t => {
        var path = hosts[t.filterName]
        if (path) {
          t.url = `${path.trimEnd('/')}/${t.routeName}`
        }
        return t
      })
      commit('SET_MENU_SERVER', _menu)
      commit('SET_WHITE_LIST',hosts['WhiteList']||[])
    },
    toggleMenuDisplay ({
      commit,
      state
    }, menuName) {
      const target = state.menus.find(m => m.name === menuName)
      const value = {
        isShow: !target.isShow
      }
      commit('SET_MENU', {
        menuName,
        value
      })
    },
    setFeedbackDialog({commit}, res) {
      commit('setFeedbackDialog', res)
    },
    setSmallClassDialog({commit},res){
      commit('setSmallClassDialog',res)
    }
  },
}
